import { publish } from '../../pubsub';
import useContainerProps from '../helpers/useContainerProps';

/**
 * Fire when user change guest filter in any AirBnB component
 * @param {Object} container
 * @param {String} guest
 *
 */
export default (container, guest) => {
  const { eventType } = useContainerProps(container);
  publish(`em.listing.${eventType}.guest`, {
    guest
  });
};
